// Alcuni componenti storici usano ancora gli helper Vue 2. In Vue 3 le
// assegnazioni e le cancellazioni dirette sono già reattive; esponiamo quindi
// gli stessi nomi per conservare il comportamento senza warning in runtime.
export function installVueCompatibility(app) {
  const globals = app?.config?.globalProperties;
  if (!globals) return;

  globals.$set = (target, key, value) => {
    if (target == null) return value;
    target[key] = value;
    return value;
  };

  globals.$delete = (target, key) => {
    if (target == null) return false;
    return delete target[key];
  };
}
